/** 3×3 sliding puzzle logic. 0 is the gap. */
export const SOLVED = [1, 2, 3, 4, 5, 6, 7, 8, 0];

export function neighbours(idx: number): number[] {
  const r = Math.floor(idx / 3), c = idx % 3;
  const out: number[] = [];
  if (r > 0) out.push(idx - 3);
  if (r < 2) out.push(idx + 3);
  if (c > 0) out.push(idx - 1);
  if (c < 2) out.push(idx + 1);
  return out;
}

export function isSolved(tiles: readonly number[]): boolean {
  return tiles.every((v, i) => v === SOLVED[i]);
}

/**
 * Shuffle by random legal moves from the solved state (always solvable), never
 * undoing the previous move, and never returning an already solved board.
 */
export function shuffle(moves = 60, rng: () => number = Math.random): number[] {
  let tiles: number[];
  do {
    tiles = [...SOLVED];
    let prev = -1;
    for (let i = 0; i < moves; i++) {
      const gap = tiles.indexOf(0);
      const opts = neighbours(gap).filter((n) => n !== prev);
      const pick = opts[Math.floor(rng() * opts.length)];
      [tiles[gap], tiles[pick]] = [tiles[pick], tiles[gap]];
      prev = gap;
    }
  } while (isSolved(tiles));
  return tiles;
}

/** Slide tile at `idx` into the gap if adjacent. Returns the new board or null. */
export function slide(tiles: readonly number[], idx: number): number[] | null {
  const gap = tiles.indexOf(0);
  if (!neighbours(gap).includes(idx)) return null;
  const next = [...tiles];
  [next[gap], next[idx]] = [next[idx], next[gap]];
  return next;
}
